<header class="app-header navbar" *ngIf="userAuthenticated">
  <button class="navbar-toggler d-lg-none" type="button" hbAppMobileSidebarToggler>&#9776;</button>
  <button *ngIf="userAuthenticated" class="navbar-toggler d-lg-block" type="button" hbAppSidebarMinimizer tabindex="0">&#9776;</button>

  <a class="navbar-brand" [href]='getDashboardLink()' *ngIf="catalog">
    <h5></h5>
  </a>

  <ul *ngIf="userAuthenticated" class="nav navbar-nav d-none">
    <li class="nav-item">
      <input type="text" class="site-search ui-inputtext ui-state-default" pInputText size="50" placeholder="{{'Header.Search' | i18next}}" id="global-search" />
    </li>
    <li class="nav-item">
      <i class="icon-search"></i>
    </li>
  </ul>

  <div class="catalog" *ngIf="catalog">
    <h5>{{catalog | uppercase}}</h5>
  </div>
  <div *ngIf="catalog">
    <hb-catalog-selector> </hb-catalog-selector>
  </div>

  <ul *ngIf="userAuthenticated" class="nav navbar-nav" style="margin-right: 20px; display: none">
    <hb-licensing></hb-licensing>

    <li class="nav-item dropdown" dropdown placement="bottom right">
      <a
        class="nav-link dropdown-toggle"
        data-toggle="dropdown"
        href="#"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"
        dropdownToggle
        (click)="(false)"
      >
        <span class="d-none">{{ loggedInUser }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
        <div class="dropdown-header text-center">
          <strong>{{'Header.Account' | i18next}}</strong>
        </div>
        <a class="dropdown-item" href="#"> <i class="fa fa-user"></i> {{'Header.Profile' | i18next}}</a>
        <a class="dropdown-item" href="#" (click)="logout()"> <i class="fa fa-lock"></i> {{'Header.Logout' | i18next}}</a>
      </div>
    </li>
  </ul>

  <ul class="nav navbar-nav doc-lr right-navbar">
    <!--
      These <li> with "d-none d-lg-block" are hidden on medium screen and below.
      Maybe these could be shown as a dropdown menu? Or at the bottom of the main menu?
    -->
    <li *ngIf="userAuthenticated && eventsManagementEnabled" class="d-none d-lg-block">
      <a class="header-link-btn" routerLinkActive="active" [routerLink]='redirectToEvents()'> <i class="fa fa-bolt"></i> {{'Header.Events' | i18next: {value : eventCount} }}</a>
    </li>

    <li *ngIf="userlaneEnabled" id="userlane-toggle-item" class="d-none d-lg-block">
      <a (click)="toggleUserlaneClicked()"><i class="fa fa-user-plus"></i> {{'Header.LearningGuide' | i18next}}  {{userlaneShown ? ('Header.Active' | i18next) : ('Header.Inactive' | i18next) }}</a>
    </li>

    <li class="d-none d-lg-block">
      <hb-about></hb-about>
    </li>

    <li>
      <hb-language-selector></hb-language-selector>
    </li>
  </ul>
</header>
